<div class="form">
  <div class="g g2c73 g15">
    <div class="left">
      <div class="section g g2c55 g15">
        <div class="gb">
          <label class="required">Name</label>
          <input type="text" nz-input [(ngModel)]="form.name" />
        </div>
        <div class="gb">
          <label class="required">Role</label>
          @if (editMode || uid) {
            @if (account) {
              <nz-tag nzColor="green">
                <app-acc-role [account]="account"></app-acc-role>
              </nz-tag>
            }
          } @else {
            <nz-select
              [(ngModel)]="form.role"
              nzShowSearch
              style="width: 100%"
              (ngModelChange)="form.rolesHandler($event)"
            >
              @for (option of form.roles; track option) {
                <nz-option [nzLabel]="option.title" [nzValue]="option"></nz-option>
              }
            </nz-select>
          }
        </div>
        <div class="gb">
          <label class="required">User Login</label>
          <input type="text" nz-input [disabled]="editMode || uid" [(ngModel)]="form.login" />
        </div>
        <div class="gb">
          <label style="display: block">Status</label>
          <nz-switch
            [(ngModel)]="form.adminStatus"
            nzCheckedChildren="Active"
            nzUnCheckedChildren="Inactive"
          ></nz-switch>
        </div>
      </div>

      <div class="section g g2c55 g15">
        <div class="gb">
          <label class="required">Job Title</label>
          <input type="text" nz-input [(ngModel)]="form.title" />
        </div>
        @if (
          !isVendorAdmin &&
          !isCompanyUser &&
          (form.role?.isCompany || (this.account?.parent && this.editMode))
        ) {
          <div class="gb">
            <label class="required">Company</label>
            <nz-select
              [(ngModel)]="form.company"
              nzShowSearch
              style="width: 100%"
              (ngModelChange)="form.rolesHandler($event)"
            >
              @for (A of accounts; track A) {
                <nz-option [nzLabel]="A.administrator" [nzValue]="A"></nz-option>
              }
            </nz-select>
          </div>
        }
      </div>

      <div class="section g g2c55 g15">
        <div class="gb">
          <label class="required">Address Line 1</label>
          <input type="text" nz-input [(ngModel)]="form.address.address1" />
        </div>
        <div class="gb">
          <label class="">Address Line 2</label>
          <input type="text" nz-input [(ngModel)]="form.address.address2" />
        </div>
      </div>
      <div class="section">
        <app-location-zipcoder
          [(form)]="form.address"
          [useGrid]="true"
          [showLabels]="true"
        ></app-location-zipcoder>
      </div>

      <!--SECURITY INFO-->
      <nz-divider nzText="Security Information"></nz-divider>

      <div class="section g g3a g15">
        <div class="gb">
          <label class="required">Email</label>
          <input type="text" nz-input [(ngModel)]="form.email" />
        </div>
        <div class="gb">
          <label class="required pwd">
            New Password
            <span
              class="pwd-check"
              [ngClass]="{ invalid: form.pwd1?.length < 8, valid: form.pwd1?.length >= 8 }"
            >
              @if ((form.pwd1?.length ?? 0) > 0) {
                <span> Length: {{ form.pwd1?.length }} </span>
              }
            </span>
          </label>
          <input type="password" nz-input [(ngModel)]="form.pwd1" />
        </div>
        <div class="gb">
          <label class="required pwd">
            Confirm Password
            <span
              class="pwd-check"
              [ngClass]="{
                invalid: form.pwd1 !== form.pwd2 || form.pwd1?.length < 8,
                valid: form.pwd1?.length >= 8 && form.pwd1 === form.pwd2,
              }"
            >
              @if ((form.pwd1?.length ?? 0) > 0) {
                <span>
                  {{
                    form.pwd1 === form.pwd2
                      ? form.pwd1?.length >= 8
                        ? 'OK'
                        : 'Min Chars 8'
                      : 'Not match!'
                  }}
                </span>
              }
            </span>
          </label>
          <input type="password" nz-input [(ngModel)]="form.pwd2" />
        </div>
      </div>
    </div>

    <div class="right">
      <div>Depending on User Role it will have different Access Levels to Inventory</div>
      <div class="gb">
        <label class="required">Phone</label>
        <input
          type="text"
          nz-input
          mask="(000) 000-0000"
          [showMaskTyped]="true"
          placeHolderCharacter="_"
          [(ngModel)]="form.contacts.phone"
        />
      </div>
      <div class="gb">
        <label class="">Fax</label>
        <input type="text" nz-input mask="000-000-0000" [(ngModel)]="form.contacts.fax" />
      </div>
      <div class="gb">
        <label [ngClass]="{ required: form.allotNotify }">Allotment Level</label>
        <input type="text" nz-input [disabled]="!form.allotNotify" [(ngModel)]="form.level" />
      </div>
      <div class="gb">
        <label nz-checkbox [(ngModel)]="form.allotNotify">
          Email when property's daily allotment falls to a certain level
        </label>
      </div>
      <div class="gb mt15">
        <label nz-checkbox [(ngModel)]="form.orderNotify">
          Email when properties receive an order
        </label>
      </div>
    </div>
  </div>
</div>

<div *nzModalFooter>
  <div class="g g2c55 g15">
    <div class="left" [ngClass]="{ expired: pwdExpired, 'not-expired': !pwdExpired }">
      @if (pwdExpired) {
        <span> <i nz-icon nzType="field-time" nzTheme="outline"></i> Password is Expired </span>
      } @else {
        <span>
          <i nz-icon nzType="issues-close" nzTheme="outline"></i> Expiration Password on
          {{ pwdExpDate }}
        </span>
      }
    </div>

    <div class="right fr">
      <button nz-button (click)="cancel()" nzType="default">Cancel</button>
      @if (!editMode) {
        <button nz-button (click)="addAccount()" nzType="primary">
          <i nz-icon nzType="save" nzTheme="outline"></i>
          {{ uid ? 'Update' : 'Add' }} Account
        </button>
      } @else {
        <button nz-button (click)="addAccount()" nzType="primary">
          <i nz-icon nzType="save" nzTheme="outline"></i> Save Changes
        </button>
      }
    </div>
  </div>
</div>
